import { z } from 'zod/v4';
export const contactChannelSchema = z.object({
    hasContact: z.boolean(),
});
export const deliverableChannelSchema = z.object({
    hasContact: z.boolean(),
    knownFailing: z.boolean(),
});
export const channelsSchema = (inner) => z.object({
    email: inner.nullable(),
    phone: inner.nullable(),
    letter: inner.nullable(),
});
//# sourceMappingURL=channel-shape.js.map